/**
 * KB-META
 * Purpose: App menu
 * Role: ui.component
 * EntryPoints: if(), switch()
 * Inputs: user && typeof user.roleLevel === 'number':unknown; profile:unknown
 * Outputs: 
 * Validation: 
 * Dependencies: 
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=component/app.menu; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { SessionService } from '../../services/session.service';
import { RoleLevel } from './roles';
import { buildMenuForRoles } from './app.menu.builder';
import { RoleOverrideService } from './role-override.service';
import { combineLatest, of } from 'rxjs';
import { GenusMediaAccessService } from './genus-media-access.service';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu implements OnInit {
  private sessionService = inject(SessionService);
  private roleOverride = inject(RoleOverrideService);
  private genusMediaAccess = inject(GenusMediaAccessService);
  model: MenuItem[] = [];
  ngOnInit() {
    const userDetails = this.sessionService.getItem('user');
    const realRoles = this.deriveRolesFromUser(userDetails);
    combineLatest([of(realRoles), this.roleOverride.override$]).subscribe(([baseRoles, override]) => {
      const effectiveRoles = override ?? baseRoles;
      this.model = buildMenuForRoles(effectiveRoles);
      this.genusMediaAccess.registerMenuModel(this.model);
    });
  }

  private deriveRolesFromUser(user: any): RoleLevel[] {
    if (user && typeof user.roleLevel === 'number') {
      const n = user.roleLevel as number;
      if (n >= 0 && n <= 5) return [n as RoleLevel];
    }
    const profile = (user?.profile || '').toLowerCase();
    switch (profile) {
      case 'gcadmin':
        return [RoleLevel.SUPER_ADMIN];
      case 'admin':
      case 'partner':
        return [RoleLevel.PARTNER_ADMIN];
      case 'contentadmin':
        return [RoleLevel.CONTENT_MANAGER];
      case 'securityadmin':
        return [RoleLevel.SECURITY_ADMIN];
      case 'analyticsadmin':
        return [RoleLevel.ANALYTICS_ADMIN];
      case 'user':
        return [RoleLevel.CLINICIAN];
      default:
        return [RoleLevel.PARTNER_ADMIN];
    }
  }
}
